import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_tips.png';

const _withScopeId = n => (_pushScopeId("data-v-80538fec"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "cms-card-block table-warp"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  },
  class: "mg-b--25"
};
const _hoisted_4 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "cursor": "pointer"
  },
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));

import ActionHeader from '@/views/common/ActionHeader/index.vue';
import Buttons from '@/components/Buttons/index.vue';
import TheAction from './TheAction.vue';
import onDemandContent from './onDemandContent/index.vue';
import { onMounted, watch, nextTick, provide } from 'vue';
import { elMessage } from '@/utils';
import { ChannelStatus, FilmType } from '@/assets/config/dicts';
import { arrToObj, clearData, deepCloneByJSON, getArrByReduce, getItemByProp } from '@/utils/tools';
import { useCommon } from '@/store/useCommon';
import { debounce } from '@/utils/tools';
import { messageBox } from '@/utils/validate';
import { ElMessageBox } from 'element-plus';
import { useI18n } from 'vue-i18n';
import { getVodCategoryApi, addVodCategoryApi, editVodCategoryApi, delVodCategoryApi, getLangOptionsApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    pageParams: {
      type: Object,
      default: {
        subAgentId: ''
      }
    },
    returnBackFn: {
      type: Function
    }
  },

  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();
    const storeCommon = useCommon();
    const tooltipContent = ref(t('分类列表中未上线状态+已下线状态的总和'));
    const theActionRef = ref(null);
    const tableRef = ref();
    const demandContent = reactive({
      visible: false
    });
    const rowItemInfo = reactive({
      id: null,
      type: null
    });
    provide('rowItemInfo', rowItemInfo);
    onMounted(async () => {
      getLangOptions();
      const productOperationsCid = sessionStorage.getItem('productOperationsCid');

      if (productOperationsCid === null) {
        elMessage('error', '找不到品牌ID');
        setTimeout(() => {
          props.returnBackFn();
        }, 500);
      } else {
        getData();
      }
    }); // 选项字典

    const DICT = {
      type: arrToObj(FilmType, 'value', 'label'),
      status: arrToObj(ChannelStatus, 'value', 'label')
    };
    const headerConfig = ref({
      title: 'VOD Category',
      btnList: [{
        label: '返回',
        func: () => {
          props.returnBackFn();
        }
      }]
    });
    const tableConfig = reactive({
      data: [],
      selected: [],
      showPageBar: false,
      isShowHeader: false,
      isCardBlock: false,
      scrollbarAlwaysOn: true,
      config: {
        loading: false
      },
      headerButtonsList: [{
        label: '添加',
        func: () => {
          dialogConfig.config.title = '添加分类';
          dialogConfig.action = 'add';
          clearData(dialogConfig.formData);
          dialogConfig.formData.status = 'valid';
          dialogConfig.formData.type = 'movie';
          dialogConfig.formData.parentClassify = 0;
          dialogConfig.formData.sourceLanguage = 'en';
          dialogConfig.visible = true;
        }
      }, {
        label: '删除',
        func: async () => {
          if (tableConfig.selected.length > 0) {
            let arr = [];
            tableConfig.selected.forEach(e => {
              if (e.sum > 0) {
                arr.push(e.name);
              }
            });

            if (arr.length > 0) {
              return elMessage('warning', '需将分类中的内容清空再删除');
            }

            let ids = getArrByReduce(tableConfig.selected, 'id');
            deleteVodCategory(ids);
          } else {
            elMessage('warning', '请选择至少一条数据');
          }
        },
        controller: config => {
          config.disabled = !tableConfig.selected.length ? true : false;
          return true;
        }
      }, {
        label: '节目数量更新',
        loading: false,
        func: debounce(async btn => {
          btn.loading = true;
          tableConfig.config.loading = true;
          const {
            subAgentId
          } = props.pageParams;

          try {
            const {
              code,
              data
            } = await getVodCategoryApi({
              subAgentId,
              cpspId: storeCommon.userData.cpspId ? storeCommon.userData.cpspId : ''
            });

            if (code == '0') {
              ElMessageBox.alert(t('节目数量更新成功'), t('提示'), {
                confirmButtonText: t('确定'),
                callback: action => {
                  btn.loading = false;
                  tableConfig.config.loading = false;
                }
              });
            } else {
              ElMessageBox.alert(t('节目数量更新失败'), t('提示'), {
                confirmButtonText: t('确定'),
                callback: action => {
                  btn.loading = false;
                  tableConfig.config.loading = false;
                }
              });
            }
          } catch (error) {
            ElMessageBox.alert(t('节目数量更新失败'), t('提示'), {
              confirmButtonText: t('确定'),
              callback: action => {
                btn.loading = false;
                tableConfig.config.loading = false;
              }
            });
          }
        }, 200)
      }],
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        // table复选框是否禁用
        selectable: (row, rowIndex) => {
          return !row.isAll;
        }
      }, {
        label: '分类名称',
        prop: 'name',
        minWidth: 200
      }, {
        label: '类型',
        prop: 'type',
        minWidth: 122,
        formatter: val => {
          if (val == 'default') {
            return t('默认');
          }

          return DICT.type[val] ? t(DICT.type[val]) : val;
        }
      }, {
        label: '状态',
        prop: 'status',
        minWidth: 150,
        formatter: val => {
          if (val !== undefined && val !== null) {
            return `<span style="color:${val === 'invalid' ? '#F92D2D' : '#29B87D'}">${t(DICT.status[val])}</span>`;
          }
        }
      }, // {
      //   label: '排序', prop: 'sequence', minWidth: '5%', widgetType: 'sortDoubleInput',
      //   onValueChange: (newValue, oldValue, done) => {
      //     console.log(newValue, oldValue);
      //     if (newValue === oldValue) {
      //       done()
      //       return
      //     }
      //     done()
      //   },
      // },
      {
        label: '节目总数',
        prop: 'programCount',
        minWidth: 120
      }, {
        label: '上线节目数量',
        prop: 'onlineProgramCount',
        minWidth: 180,
        formatter: value => {
          return value == null ? 0 : value;
        }
      }, {
        label: '未上线节目数量',
        prop: 'offlineProgramCount',
        minWidth: 180,
        formatter: value => {
          return value == null ? 0 : value;
        }
      }, {
        label: '描述',
        prop: 'description',
        minWidth: 200
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        showOverflowTooltip: false,
        fixed: 'right',
        buttonsList: [{
          label: '修改',
          func: async row => {
            dialogConfig.config.title = 'Edit Category';
            dialogConfig.action = 'edit';
            dialogConfig.formData = deepCloneByJSON(row);
            dialogConfig.visible = true;
            setTimeout(() => {
              let typeItem = getItemByProp(theActionRef.value.formConfig.formList, 'type');

              if (typeItem) {
                if (row.sum > 0) {
                  typeItem.disabled = true;
                } else {
                  typeItem.disabled = false;
                }
              }
            });
          },
          controller: row => {
            return !row.isAll;
          }
        }, {
          label: '内容列表',
          func: row => {
            const {
              id,
              type
            } = row;
            rowItemInfo.id = id;
            rowItemInfo.type = type;
            demandContent.visible = true;
          }
        }, // { label: '添加子分类', func: () => { } },
        {
          label: '删除',
          func: row => {
            if (row.sum > 0) {
              return elMessage('warning', '需将分类中的内容清空再删除');
            }

            deleteVodCategory([row.id]);
          },
          controller: row => {
            return !row.isAll;
          }
        }]
      }],
      selectChange: val => {
        tableConfig.selected = val;
      },
      rowStyle: ({
        row
      }) => {
        if (row.isAll) {
          return {
            backgroundColor: "#FEFAE2"
          };
        }
      }
    });
    const dialogConfig = reactive({
      visible: false,
      action: 'add',
      config: {
        title: '添加分类',
        destroyOnClose: true
      },
      formData: {
        name: '',
        parent: '',
        sequence: '',
        status: 'valid',
        type: 'movie',
        sourceLanguage: 'en',
        // adult: 0,
        description: '',
        parentClassify: 0
      },
      confirm: done => {
        dialogConfig.action === 'add' ? handleAdd(done) : handleEdit(done);
      }
    }); // 添加点播分类

    const handleAdd = async done => {
      theActionRef.value.formRef.mForm.validate(async valid => {
        if (valid) {
          const {
            formData
          } = dialogConfig;
          console.log('formData', formData);
          formData.name = formData.name.trim();
          const {
            subAgentId
          } = props.pageParams;

          try {
            const {
              code
            } = await addVodCategoryApi({ ...formData,
              subAgentId
            });

            if (code == '0') {
              elMessage('success', '新增成功');
              getData();
              dialogConfig.visible = false;
            }
          } catch (error) {}
        }

        done();
      });
    }; // 编辑点播分类


    const handleEdit = async done => {
      theActionRef.value.formRef.mForm.validate(async valid => {
        if (valid) {
          const {
            formData
          } = dialogConfig;
          formData.name = formData.name.trim();
          const {
            subAgentId
          } = props.pageParams;

          try {
            const {
              code
            } = await editVodCategoryApi({ ...formData,
              subAgentId
            });

            if (code == '0') {
              elMessage('success', '编辑成功');
              getData();
              dialogConfig.visible = false;
            }
          } catch (error) {}
        }

        done();
      });
    }; // 删除点播分类


    const deleteVodCategory = ids => {
      const {
        subAgentId
      } = props.pageParams;
      messageBox('确定删除所选数据吗?').then(async () => {
        const {
          code
        } = await delVodCategoryApi(ids);

        if (code == '0') {
          elMessage('success', '删除成功');
          getData();
        }
      });
    };

    const dataTotal = ref(0); // 获取点播分类列表信息

    const getData = async done => {
      tableConfig.config.loading = true;

      try {
        const {
          subAgentId
        } = props.pageParams;
        const {
          code,
          data
        } = await getVodCategoryApi({
          subAgentId,
          cpspId: storeCommon.userData.cpspId ? storeCommon.userData.cpspId : ''
        });

        if (code == '0') {
          tableConfig.data = [...data];

          if (data.length) {
            let allItem = {
              name: 'All',
              type: 'default',
              programCount: 0,
              offlineProgramCount: 0,
              onlineProgramCount: 0,
              description: t('终端不显示'),
              isAll: true,
              id: subAgentId //params.categoryId

            };
            data.forEach(item => {
              allItem.programCount = item.programCount + allItem.programCount;
              allItem.offlineProgramCount = item.offlineProgramCount + allItem.offlineProgramCount;
              allItem.onlineProgramCount = item.onlineProgramCount + allItem.onlineProgramCount;
            });
            tableConfig.data.unshift(allItem);
          }

          dataTotal.value = data.length ? data.length : 1;
        }
      } catch (error) {
        console.log('424err', error);
      }

      tableConfig.config.loading = false;
      done && done();
    };

    const setOptionsBtnColumnWidth = width => {
      const findItem = tableConfig.columnList.find(item => item.label == '操作');
      findItem ? findItem.width = width : '';
    };

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    };

    const langOptions = ref([]); // 获取语言列表

    const getLangOptions = async () => {
      // 获取过一次直接存储
      if (sessionStorage.getItem('themeLangOptions')) {
        return langOptions.value = JSON.parse(sessionStorage.getItem('themeLangOptions'));
      }

      const {
        code,
        data
      } = await getLangOptionsApi();

      if (code == 0) {
        langOptions.value = data ? data : [];
        sessionStorage.setItem('themeLangOptions', JSON.stringify(data));
      }
    };

    watch(() => dialogConfig.visible, val => {
      if (val) {
        setTimeout(() => {
          if (dialogConfig.action === 'add') {
            theActionRef.value.setLastSortNum(dataTotal.value == 1 ? dataTotal.value : dataTotal.value + 1, dataTotal.value == 1 ? dataTotal.value : dataTotal.value + 1);
            dialogConfig.formData.sequence = dataTotal.value == 1 ? String(dataTotal.value) : String(dataTotal.value + 1);
          } else if (dialogConfig.action === 'edit') {
            theActionRef.value.setLastSortNum(dataTotal.value, dataTotal.value + 1);
          }
        });
      }
    });
    watch(() => demandContent.visible, val => {
      if (!val) {
        getData();
      }
    });
    return (_ctx, _cache) => {
      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_MDialog = _resolveComponent("MDialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", null, [!demandContent.visible ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ActionHeader, {
        config: headerConfig.value
      }, null, 8, ["config"]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(Buttons, {
        "buttons-list": tableConfig.headerButtonsList
      }, null, 8, ["buttons-list"]), _createVNode(_component_TableColumnOptionBtn, {
        "column-list": tableConfig.columnList,
        onFilterColumnItemChange: filterColumnItemChange
      }, null, 8, ["column-list"])]), _createVNode(_component_common_table, {
        ref_key: "tableRef",
        ref: tableRef,
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        onSelectionChange: tableConfig.selectChange
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": tableConfig.columnList
        }, {
          title: _withCtx(column => [column.nodeDate.prop == 'offlineProgramCount' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(_ctx.$t(column.label)), 1), _createVNode(_component_el_tooltip, {
            "popper-class": "self-popper",
            content: tooltipContent.value,
            placement: "top",
            effect: "light"
          }, {
            default: _withCtx(() => [_hoisted_5]),
            _: 1
          }, 8, ["content"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "onSelectionChange"])])), [[_directive_loading, tableConfig.config.loading]])])) : _createCommentVNode("", true), _createVNode(_component_MDialog, {
        autoLoading: "",
        nativeConfig: {
          closeOnClickModal: false,
          width: '750px'
        },
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogConfig.visible = $event),
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [_createVNode(TheAction, {
          ref_key: "theActionRef",
          ref: theActionRef,
          modelValue: dialogConfig.formData,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogConfig.formData = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"]), demandContent.visible ? (_openBlock(), _createBlock(onDemandContent, {
        key: 1,
        returnBackFn: () => {
          demandContent.visible = false;
          tableConfig.selected = [];
        }
      }, null, 8, ["returnBackFn"])) : _createCommentVNode("", true)]);
    };
  }

});